// type CSSTypeMapKeysWithPicker = ExtractTypeValuesOnly<typeof cssTypeToPrimitiveMapping, "color">
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Swatch } from "./swatch";
import { SInputV2 } from "../../../SInputV2";
import { useCallback, useEffect, useMemo, useState } from "react";
import { SSlider } from "../../../SSlider";
import React from "react";
import { debounce } from "es-toolkit";
export { Swatch };
const getCSSColor = (_value)=>{
    let value = _value;
    if (value.trim().length === 7) {
        value = `${value}ff`;
    }
    // separate the last 2 characters from the color
    const lastTwo = value.slice(-2);
    // get the string without the last two, assuming value can be of any length
    const color = value.slice(0, -2);
    // const color = value.slice(0, 7)
    const opacity = Math.round(parseInt(lastTwo, 16) / 255 * 100);
    return {
        color: color || "#000000",
        opacity: opacity === 0 || opacity ? opacity : undefined
    };
};
const cssColorToRGBA = (value)=>{
    if (value.opacity === undefined) {
        return `${value.color}ff`;
    }
    const opacity = Math.round(value.opacity / 100 * 255).toString(16).padStart(2, "0");
    return `${value.color}${opacity}`;
};
export const CSSColorEditor = (props)=>{
    const { value } = props;
    const cssColor = useMemo(()=>getCSSColor(value?.value || "#000000ff"), [
        value
    ]);
    const [colorInputValue, setColorInputValue] = useState(value ? cssColor.color : "");
    useEffect(()=>{
        setColorInputValue(cssColor.color);
    }, [
        cssColor.color
    ]);
    // We know now that literalValue is `css-length` or `css-string`
    const getNextState = (currentState, action)=>{
        switch(action.type){
            case "OPACITY_KEY_DOWN":
                {
                    const { event } = action;
                    const key = event.key;
                    const opacity = currentState.value.opacity || 0;
                    const KeyMap = {
                        ArrowUp: event.shiftKey ? 10 : 1,
                        ArrowDown: event.shiftKey ? -10 : -1
                    };
                    if (key in KeyMap) {
                        let newValue = Math.round(opacity + KeyMap[key]);
                        newValue = Math.round(Math.min(100, Math.max(0, newValue)));
                        return {
                            value: {
                                ...currentState.value,
                                opacity: newValue
                            }
                        };
                    }
                    break;
                }
            case "COLOR_CHANGE":
                {
                    let { value } = action;
                    // if value is 6 digit hex without a #, add a #. regex to check for 6 digit hex
                    if (value.match(/^([A-Fa-f0-9]{3})$/) || value.match(/^([A-Fa-f0-9]{6})$/)) {
                        value = "#" + value;
                    }
                    return {
                        value: {
                            ...currentState.value,
                            color: value
                        }
                    };
                    break;
                }
            case "OPACITY_CHANGE":
                {
                    let { opacity } = action;
                    return {
                        value: {
                            ...currentState.value,
                            // round int between 0 100
                            opacity: Math.round(Math.min(100, Math.max(0, parseInt(opacity)))) || 0
                        }
                    };
                    break;
                }
        }
        // Let the end return the same value
        return {
            value: currentState.value
        };
    };
    const dispatch = useCallback((action)=>{
        const nextState = value ? getNextState({
            value: getCSSColor(value?.value)
        }, action) : getNextState({
            value: {
                color: "",
                opacity: 100
            }
        }, action);
        // if (nextState.value) setCSSColor(nextState.value)
        if (nextState.value) {
            props.onChangeValue && props.onChangeValue({
                type: "css-color",
                value: cssColorToRGBA(nextState.value)
            });
            setColorInputValue(nextState.value.color);
        }
    }, [
        getNextState,
        value
    ]);
    // Create a debounced onChange function
    const debouncedOnChange = debounce((value)=>{
        dispatch({
            type: "COLOR_CHANGE",
            value
        });
    }, 200);
    const onColorBlur = ({ color })=>{
        if (color === "") {
            return;
        }
        // if color is 6 digit hex without a #, add a #
        if (color.match(/^([A-Fa-f0-9]{3})$/) || color.match(/^([A-Fa-f0-9]{6})$/)) {
            color = "#" + color;
        }
        // create a fake div to test the color
        const fakeDiv = document.createElement("div");
        fakeDiv.style.color = color;
        document.body.appendChild(fakeDiv);
        const computedColor = window.getComputedStyle(fakeDiv).color;
        document.body.removeChild(fakeDiv);
        // parse the rgba value to r, g, b, a values. keep in mind it could be rgb or rgba and there could be decimals
        const rgba = computedColor.replace("rgba(", "").replace("rgb(", "").replace(")", "").split(",").map((color)=>parseFloat(color));
        // convert the rgb to hex
        const hex = rgba.slice(0, 3).map((color)=>color.toString(16).padStart(2, "0")).join("");
        if (rgba.length === 4) {
            const opacity = Math.round(rgba[3] * 100);
            // dispatch opacity
            // setCSSColor({ color: `#${hex}`, opacity })
            props.onChangeValue && props.onChangeValue({
                type: "css-color",
                value: cssColorToRGBA({
                    color: `#${hex}`,
                    opacity
                })
            });
            setColorInputValue(`#${hex}`);
        } else {
            dispatch({
                type: "COLOR_CHANGE",
                value: `#${hex}`
            });
        }
    };
    // Update the onChange handler to use debouncedOnChange
    const handleChange = (e)=>{
        // on safari this gets called twice, once with type input and once with type change. type input has the correct value while type change is off
        if (e.nativeEvent.type === "input") {
            // safari fix
            debouncedOnChange(e.target.value);
        }
    };
    const ref = React.useRef(null);
    const [isSmall, setIsSmall] = useState(false);
    React.useEffect(()=>{
        const resizeObserver = new ResizeObserver((entries)=>{
            for (let entry of entries){
                console.log(entry.contentRect.width);
                setIsSmall(entry.contentRect.width < 200);
            }
        });
        resizeObserver.observe(ref.current);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, []);
    return /*#__PURE__*/ _jsx("div", {
        ref: ref,
        children: /*#__PURE__*/ _jsxs("div", {
            className: `relative bg-grayscale-dark rounded-md border border-white/10 grid ${isSmall ? "grid-cols-[auto,1fr,53px]" : "grid-cols-[auto,1fr,1fr,60px]"} items-center pl-[4px]`,
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "relative overflow-hidden !cursor-pointer transition hover:scale-[1.05] active:scale-[0.9]",
                    children: [
                        /*#__PURE__*/ _jsx(Swatch, {
                            color: value?.value || "#00000000",
                            onClick: ()=>{},
                            isDyanamic: props.isDynamic
                        }),
                        /*#__PURE__*/ _jsx("input", {
                            tabIndex: -1,
                            className: "appearence-none !cursor-pointer opacity-0 absolute top-0 left-0 bottom-0 right-0",
                            type: "color",
                            value: cssColor.color,
                            onChange: handleChange,
                            onBlur: (e)=>{
                                // log the color value
                                console.log("[!] color blur", e.target.value);
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(SInputV2, {
                    borderless: true,
                    tabIndex: 1,
                    className: "text-[13px] !pl-2 !pr-0 !h-[30px] !py-0",
                    // value={value ? cssColor.color : ""}
                    value: colorInputValue,
                    placeholder: "#000000",
                    onKeyDown: (event)=>{
                        // if enter is pressed, blur the input
                        if (event.key === "Enter") {
                            event.currentTarget.blur();
                        }
                    },
                    onBlur: (e)=>{
                        onColorBlur({
                            color: e.target.value
                        });
                    },
                    onChange: (e)=>{
                        // dispatch({ type: "COLOR_CHANGE", value: e.target.value })
                        setColorInputValue(e.target.value);
                    }
                }),
                !isSmall && /*#__PURE__*/ _jsx("div", {
                    className: "border-l border-white/10  items-center px-3",
                    children: /*#__PURE__*/ _jsx(SSlider, {
                        min: 0,
                        max: 100,
                        step: 1,
                        className: "!h-[30px] !w-auto",
                        value: cssColor.opacity || 0,
                        onChange: (value)=>{
                            dispatch({
                                type: "OPACITY_CHANGE",
                                opacity: value.toString()
                            });
                        }
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: `border-l border-white/10 grid grid-cols-[1fr,auto] items-center`,
                    children: [
                        /*#__PURE__*/ _jsx(SInputV2, {
                            borderless: true,
                            type: "number",
                            min: 0,
                            max: 100,
                            tabIndex: 1,
                            className: `text-[13px] !mx-0 !h-[30px] !py-0 !text-center ${isSmall ? "!px-0 !w-[35px]" : "!px-2"}`,
                            value: value ? cssColor.opacity || "" : "",
                            onBlur: ()=>{
                                // if cssColor.opacity is undefined, set it to 100
                                if (cssColor.opacity === undefined) {
                                    dispatch({
                                        type: "OPACITY_CHANGE",
                                        opacity: "100"
                                    });
                                }
                            },
                            placeholder: value ? "0" : "100",
                            onChange: (e)=>dispatch({
                                    type: "OPACITY_CHANGE",
                                    opacity: e.target.value
                                }),
                            onKeyDown: (event)=>dispatch({
                                    type: "OPACITY_KEY_DOWN",
                                    event
                                })
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "text-[13px] opacity-70  pr-2",
                            children: "%"
                        })
                    ]
                })
            ]
        })
    });
};
